import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import { getServiceErrorMessage } from "../../../helpers"
import { Context, Transitions } from "../../../types"
import { getPlanRefIdByRefScope } from "../../../../../study-plans/helpers"

export const getTeacherRelevantPlanInfoTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  entry: assign<Context>({ loading: true }),
  exit: assign<Context>({ loading: false }),
  invoke: {
    src: "getTeacherRelevantPlanInfo",
    onDone: {
      target: "#StudyPlan.get_current_plan",
      actions: assign<Context, DoneInvokeEvent<any>>((ctx, evt) => {
        let selectedEntity = ctx.selectedEntity
        let isStudentPlan = ctx.isStudentPlan

        if (ctx.isStudyPlanV2Enabled) {
          const classFilter = ctx.reportingFiltersState?.class?.[0]
          const studentFilter = ctx.reportingFiltersState?.student?.[0]

          const classPlanByFilter = evt.data.classes?.find(
            item => item.entityId === classFilter
          )
          const studentPlanByFilter = evt.data.students?.find(
            item => item.entityId === studentFilter
          )

          selectedEntity = studentPlanByFilter || classPlanByFilter || null
          isStudentPlan = !!studentPlanByFilter
        }

        const isSelectedEntityExist = !!evt.data[
          isStudentPlan ? "students" : "classes"
        ].find(item => item?.entityId === selectedEntity?.entityId)

        return {
          relevantClassPlansInfo: evt.data.classes,
          relevantStudentPlansInfo: evt.data.students,
          recommendedPlanLevel: evt.data?.recommendedPlanLevel,
          recommendedPlanId: evt.data?.recommendedPlanId,
          teacherPlanId: evt.data.teacherPlanId,

          ...(!isSelectedEntityExist
            ? {
                selectedEntity: null,
                selectedPlanId: "",
                currentPlanScope: ctx.selfRefScope.scope,
                currentTargetPlanRefId: getPlanRefIdByRefScope(ctx.selfRefScope)
              }
            : ctx.isStudyPlanV2Enabled
            ? {
                isStudentPlan,
                selectedEntity
              }
            : {})
        }
      })
    },
    onError: {
      target: "#StudyPlan.teacher_view.idle",
      actions: assign<Context, DoneInvokeEvent<any>>((ctx, evt) => ({
        loading: false,
        ...(!!ctx.teacherAssignedSubjects.length && {
          snackbar: {
            message: getServiceErrorMessage("getTeacherRelevantPlanInfo", {
              errorReason: evt.data.message
            }),
            withUndo: false,
            error: true
          }
        })
      }))
    }
  }
}
